const TRANSLATION = {
  buyModal: {
    afterFree: 'अपने नि: शुल्क परीक्षण के बाद',
    btn: 'मुफ्त में आजमाएं',
    freeTrial: '3-दिवसीय नि: शुल्क परीक्षण',
    monthLabel: 'महीना',
    selectLabel: 'एक योजना का चयन करें',
    title: 'सदस्यता योजना',
    yearLabel: 'वर्ष',
  },
  contact: {
    block1:
      'अनुकूलन, प्रश्न, या सुझाव के लिए, कृपया हमसे संपर्क@noam.tools पर संपर्क करें। हम तुरंत जवाब देंगे।',
    block2: '★★★★★ पर Google Apps एक्सटेंशन स्टोर पर हमें रेटिंग देकर हमारा समर्थन करें।',
    block3: 'इस एक्सटेंशन को साझा करके दूसरों की मदद करें:',
    title: 'हमसे संपर्क करें',
  },
  help: {
    AquickOverviewOfNoam: 'NOAM का एक त्वरित अवलोकन',
    ChatPDF: 'चैट पीडीएफ',
    ChatPDF2: 'चैटपडीएफ',
    FavoritesManagement: 'पसंदीदा प्रबंधन',
    Fixedplugin: 'नियत प्लगइन',
    Focusing: 'ध्यान केंद्रित',
    Free: 'मुक्त',
    FreeTrialBenefits: 'नि: शुल्क परीक्षण लाभ',
    GoWithWikipedia: 'विकिपीडिया के साथ जाओ',
    GoWithYouTube: 'YouTube के साथ जाओ',
    HoverTranslation: 'होवर अनुवाद',
    Howtouse: 'का उपयोग कैसे करें',
    ImageTranslation: 'छवि अनुवाद',
    InstantTranslation: 'तुरंत अनुवाद',
    Membership: 'सदस्यता',
    NoamHelp: 'NOAM आपको अनुवाद करने और संक्षेप में मदद करता है',
    PDFparallelTranslation: 'पीडीएफ समानांतर अनुवाद',
    ParallelTranslation: 'समानांतर अनुवाद',
    SkipAllSteps: 'सभी चरणों को छोड़ दें',
    Summary: 'सारांश',
    Translation: 'अनुवाद',
    TryItForFree: 'इसका उपयोग मुफ्त में करें',
    Video: 'वीडियो',
    VideoSummary: 'वीडियो सारांश',
    VideoTranslation: 'वीडियो अनुवाद',
    WebSummary: 'वेब सारांश',
    WordSelectionTranslation: 'शब्द चयन अनुवाद',
    benefits: 'हमारे पास आपके लिए इंतजार कर रहे हैं!',
    dayFree: '3-दिवसीय नि: शुल्क परीक्षण',
    done: 'हो गया',
    next: 'अगला',
    pin: 'आसान पहुंच के लिए पिन नोम ～～',
    planIsNotExist: 'योजना उपलब्ध नहीं है',
    startWiki: 'चलो विकिमीडिया के साथ शुरू करते हैं!',
    startYoutube: 'चलो YouTube के साथ शुरू करें!',
    try: 'कोशिश करके देखो',
    tryNow: 'अब इसे आज़माएं!',
  },
  home: {
    PDFTranslate: {
      desc: 'द्विभाषी अनुवाद + चैट पीडीएफ',
      sub1: {
        desc: 'द्विभाषी पढ़ने से आप मूल पाठ और अनुवाद की तुलना में साइड-बाय-साइड की तुलना करते हैं, पढ़ने की दक्षता में सुधार करते हैं।',
        title: 'द्विभाषी पठन',
      },
      sub2: {
        desc: 'AI विश्लेषण करता है और सारांशित करता है, और पीडीएफ सामग्री के आधार पर आपके प्रश्नों का उत्तर दे सकता है।',
        title: 'चैट पीडीएफ',
      },
      sub3: {
        desc: 'अधिक सटीकता और दक्षता के लिए एआई-संचालित पीडीएफ अनुवाद।',
        title: 'सटीकता और दक्षता',
      },
      title: 'पीडीएफ अनुवाद',
    },
    aiAssistant: {
      desc: 'वेब ट्रांसलेशन होशियार और अधिक सुविधाजनक बनाना',
      panel1: {
        desc: 'द्विभाषी क्रॉस-रेफरेंसिंग अनुवाद आपको अनुवाद के साथ मूल पाठ की तुलना करने में मदद करते हैं ताकि आप बेहतर समझ सकें और अपनी पढ़ने की दक्षता में सुधार कर सकें।',
        title: 'द्विभाषी अनुवाद',
      },
      panel2: {
        left: {
          desc: 'वेब पेज को ब्राउज़ करते समय, अनुवाद को देखने के लिए आपको अनुवाद करने की आवश्यकता उस सामग्री पर होवर करें।',
          title: 'होवर अनुवाद',
        },
        right: {
          desc: 'वेब पेज को ब्राउज़ करते समय, उस पाठ का चयन करें जिसे आप अनुवाद देखने के लिए अनुवाद करना चाहते हैं।',
          title: 'पाठ चयन अनुवाद',
        },
      },
      panel3: {
        one: {
          desc: 'अनुवाद करें और वेब पेज और वीडियो सामग्री को कभी भी, कहीं भी, एक चिकनी अनुभव के लिए संक्षेप करें!',
          title: 'बिंदु और क्लिक करें',
        },
        three: {
          desc: 'AI- चालित बड़े भाषा मॉडल एक बढ़ाया पढ़ने के अनुभव के लिए अनुवाद सटीकता और स्थिरता सुनिश्चित करता है।',
          title: 'ऐ संचालित',
        },
        two: {
          desc: 'मल्टी-लैंग्वेज फुल कवरेज, द्विभाषी बैरियर-फ्री रीडिंग, वन-क्लिक ट्रांसलेशन-अंतर का अनुभव करें!',
          title: 'अधिक व्यापक और सुविधाजनक',
        },
      },
      panel4: {
        tab1: {
          desc: 'आपकी दक्षता विशेषज्ञ - चैटगिप्ट का उपयोग करते हुए, NOAM आपको समय बचाने के लिए YouTube वीडियो सामग्री का अनुवाद और सारांशित करता है!',
          key: 'वीडियो',
          title: 'वीडियो अनुवाद और सारांश',
        },
        tab2: {
          desc: 'वेब ब्राउज़ करते समय छवियों का अनुवाद करने के लिए क्लिक करें।',
          key: 'छवि',
          title: 'छवि अनुवाद',
        },
        tab3: {
          desc: 'तुरंत वेब पेजों से महत्वपूर्ण जानकारी निकालता है और एक सारांश प्रदान करता है, जो आपकी पढ़ने की दक्षता को बढ़ाता है।',
          key: 'वेब',
          title: 'वेब अनुवाद और सारांश',
        },
        tag1: 'सरल',
        tag2: 'कुशल',
        tag3: 'समझने में आसान',
      },
      title: 'एआई सहायक',
    },
    getStart: 'शुरू हो जाओ',
    getStartedForFree: 'मुफ्त में शुरुआत करें',
    howItWork: {
      desc: 'NOAM AI मॉडल को क्रॉस-लैंग्वेज वेब पेज ट्रांसलेशन और सारांश, पीडीएफ और इमेज ट्रांसलेशन, वीडियो ट्रांसलेशन और सारांश के लिए एक बुद्धिमान अनुभव प्रदान करने के लिए एआई मॉडल को एकीकृत करता है',
      title: 'यह काम किस प्रकार करता है',
    },
    lastBlock: { desc: 'एक चिकनी पढ़ने के अनुभव के लिए बेहतर एआई अनुवाद' },
    top: {
      desc: 'NOAM एक मुफ्त AI ब्राउज़र एक्सटेंशन है जो आपको वेब पेज, वीडियो और पीडीएफ सामग्री का अनुवाद और संक्षेप में मदद करता है। \\ n NOAM में शामिल हों और जादू का अनुभव करें!',
      title1: 'एक जादू',
      title2: 'एक क्लिक',
    },
    userReviews: { desc: 'क्रोम वेब स्टोर पर पांच सितारा समीक्षा', title: 'उपयोगकर्ता की समीक्षा' },
  },
  installTips: {
    btn: 'अब इसे आजमाओ',
    text: 'अधिक सुविधाओं को अनलॉक करने के लिए "NOAM ब्राउज़र प्लगइन" स्थापित करें! वेब क्रॉस-रेफरेंसिंग, \\ n वेब वीडियो सारांश, और बहुत कुछ!',
  },
  locale: {
    af: 'अफ्रीकी',
    am: 'अम्हारिक्',
    ar: 'अरबी',
    as: 'असमिया',
    auto: 'ऑटो का पता लगाने',
    az: 'आज़रबाइजानी',
    ba: 'बशख़िर',
    bg: 'बल्गेरियाई',
    bn: 'बांग्ला',
    bo: 'तिब्बती',
    bs: 'बोस्नियाई',
    ca: 'कातालान',
    cs: 'चेक',
    cy: 'वेल्श',
    da: 'डेनिश',
    de: 'जर्मन',
    dsb: 'कम सोरबियन',
    dv: 'दिवेही',
    el: 'यूनानी',
    en: 'अंग्रेज़ी',
    es: 'स्पैनिश',
    et: 'एस्तोनियावासी',
    eu: 'बस्क',
    fa: 'फ़ारसी',
    fi: 'फिनिश',
    fil: 'filipino',
    fj: 'फिजी',
    fr: 'फ्रांसीसी',
    frCA: 'फ्रेंच (कनाडा)',
    ga: 'आयरिश',
    gl: 'गैलिशियन्',
    gom: 'कोंकणी',
    gu: 'गुजराती',
    ha: 'होउसा',
    he: 'यहूदी',
    hi: 'हिंदी',
    hr: 'क्रोएशियाई',
    hsb: 'ऊपरी सोरबियन',
    ht: 'हाईटियन क्रियोल',
    hu: 'हंगेरी',
    hy: 'अर्मेनियाई',
    id: 'इन्डोनेशियाई',
    ig: 'ईग्बो',
    ikt: 'Inuinnaqtun',
    is: 'आइसलैंड का',
    it: 'इतालवी',
    iu: 'इनूकीटूत्',
    iuLatn: 'Inuktitut (लैटिन)',
    ja: 'जापानी',
    ka: 'जॉर्जीयन्',
    kk: 'कजाख',
    km: 'खमेर',
    kmr: 'कुर्दिश (उत्तरी)',
    kn: 'कन्नडा',
    ko: 'कोरियाई',
    ku: 'कुर्दिश (केंद्रीय)',
    ky: 'किरगिज़',
    ln: 'लिंगाला',
    lo: 'लाओ',
    lt: 'लिथुआनियाई',
    lug: 'गंडा',
    lv: 'लात्वीयावासी',
    lzh: 'चीनी (साहित्यिक)',
    mai: 'मैथिली',
    mg: 'मालागासी',
    mi: 'माओरी',
    mk: 'मेसीडोनियन',
    ml: 'मलयालम',
    mnCyrl: 'मंगोलियन (सिरिलिक)',
    mnMong: 'मंगोलियाई (पारंपरिक)',
    mr: 'मराठी',
    ms: 'मलायी',
    mt: 'मोलतिज़',
    mww: 'हमोंग दाऊ',
    my: 'म्यांमार (बर्मी)',
    nb: 'नार्वेजियन',
    ne: 'नेपाली',
    nl: 'डच',
    noSearchLang: 'भाषा समर्थित नहीं है',
    nso: 'सेसोथो सा लेबोआ',
    nya: 'न्यानजा',
    or: 'ओडिया',
    otq: 'क्वेरेरो ओटोमी',
    pa: 'पंजाबी',
    pl: 'ERROR: [Polish]',
    placeholder: 'खोज',
    prs: 'दारि',
    ps: 'पश्तो',
    pt: 'पुर्तगाली (ब्राजील)',
    ptPT: 'पुर्तगाली (पुर्तगाल)',
    ro: 'रोमानियाई',
    ru: 'रूसी',
    run: 'रुन्दी',
    rw: 'किन्यारवाण्डा',
    sd: 'सिंधी',
    si: 'सिंहली',
    sk: 'स्लोवाक',
    sl: 'स्लोवेनियाई',
    sm: 'सामोन',
    sn: 'सोणा',
    so: 'सोमाली',
    sq: 'अल्बानियन',
    srCyrl: 'सर्बियाई (सिरिलिक)',
    srLatn: 'सर्बियाई (लैटिन)',
    st: 'सेसोथो',
    sv: 'स्वीडिश',
    sw: 'swahili',
    ta: 'तामिल',
    te: 'तेलुगू',
    th: 'थाई',
    ti: 'तिग्रिन्या',
    tk: 'तुक्रमेन',
    tlhLatn: 'क्लिंगन (लैटिन)',
    tlhPiqd: 'क्लिंगन (पिकाद)',
    tn: 'सेत्सवाना',
    to: 'टोंगन',
    tr: 'तुर्की',
    tt: 'टाटर',
    ty: 'ताहितियन',
    ug: 'उईघुर',
    uk: 'यूक्रेनी',
    ur: 'उर्दू',
    uz: 'उज़बेक (लैटिन)',
    vi: 'वियतनामी',
    xh: 'षोसा',
    yo: 'योरूबा',
    yua: 'युकाटेक माया',
    yue: 'कैंटोनीज़ (पारंपरिक)',
    zh: 'चीनी',
    zhHans: 'सरलीकृत चीनी',
    zhHant: 'चीनी पारंपरिक',
    zu: 'ज़ुलु',
  },
  login: {
    and: 'और',
    btn: 'Google के साथ लॉग इन करें',
    btn1: 'अभी लॉगिन करें',
    desc: 'अधिक अनुभवों को अनलॉक करने के लिए लॉग इन करें',
    policy: 'गोपनीयता नीति',
    terms: 'उपयोग की शर्तें',
    tips: 'साइन अप करके, मैं सहमत हूं',
    title: 'NOAM में आपका स्वागत है',
  },
  pageFooter: {
    follow: { facebook: 'फेसबुक', title: 'अनुसरण करना', twitter: 'ट्विटर' },
    legal: { policy: 'गोपनीयता नीति', terms: 'सेवा की शर्तें', title: 'कानूनी' },
    product: {
      image: 'छवि अनुवाद',
      pdf: 'पीडीएफ अनुवाद',
      title: 'उत्पादों',
      video: 'वीडियो अनुवाद और सारांश',
      web: 'वेब अनुवाद और सारांश',
    },
    resources: { title: 'संसाधन' },
    tools: { title: 'उपकरण', pdf: 'पीडीएफ अनुवाद' },
  },
  pageHeader: {
    contact: 'संपर्क',
    help: 'मदद',
    logout: 'ERROR: [Log Out]',
    logoutSucc: 'बाहर आ गये।',
    pricing: 'मूल्य निर्धारण',
    settings: 'सेटिंग',
    signUp: 'लॉग इन करें',
  },
  pdf: {
    autoDetect: 'ऑटो का पता लगाने',
    cancelBtn: 'रद्द करना',
    cancelUpload: 'रद्द करना',
    chatPdf: {
      summaryError: 'सारांश विफल हो गया, कृपया बाद में पुनः प्रयास करें',
      chatError: 'चैट विफल हो गई, कृपया बाद में पुनः प्रयास करें',
      Search: 'खोज',
      cancel: 'रद्द करना',
      chatTitle: 'NOAM में आपका स्वागत है! यहाँ आपके पीडीएफ का सारांश है:',
      clear: 'स्पष्ट',
      clearContent:
        'यह एक नई बातचीत शुरू करेगा। वर्तमान बातचीत को बचाया नहीं जाएगा। क्या आपको यकीन है?',
      clearDialogTitle: 'कृपया पुष्टि करें',
      clearSucc: 'साफ़ किया गया',
      copy: 'प्रतिलिपि',
      copySucc: 'कॉपी किया गया',
      delete: 'मिटाना',
      deleteCancel: 'रद्द करना',
      deleteContent:
        'एक बार हटाए जाने के बाद यह पीडीएफ बरामद नहीं किया जा सकता है। क्या आपको यकीन है?',
      deleteOk: 'मिटाना',
      deleteSuccess: 'हटाए गए',
      deleteTitle: 'DELETE की पुष्टि करें',
      expand: 'गिर जाना',
      historyTitle: 'इतिहास',
      listError:
        'पढ़ने की सूची लोड करने में विफल। कृपया बाद में पुनः प्रयास करें, या समर्थन से संपर्क करें।',
      loading: 'लोड हो रहा है ...',
      noDataDesc: 'अभी तक कोई इतिहास नहीं।',
      noMore: 'कोई और अधिक सामग्री नहीं।',
      placeholder: 'इस पीडीएफ के बारे में कुछ भी पूछें',
      summaryTitle: 'आपको इन सवालों में रुचि हो सकती है:',
    },
    collectionEmpty: 'आपका संग्रह खाली है।',
    collectionTab: 'नोट',
    dataLoading: 'लोड हो रहा है ...',
    dialogContent: 'क्या आप वाकई इसे हटाना चाहते हैं?',
    dialogTitle: 'कृपया पुष्टि करें',
    download: {
      both: 'द्विभाषिक',
      btn: 'बचाना',
      cancel: 'इस विंडो को बंद करने से पीडीएफ डाउनलोड रद्द हो जाएगा। आप आप रद्द करना चाहते हैं?',
      desc: 'डिवाइस को सहेजें: छवियों के रूप में अनुवाद डाउनलोड करता है; सहेजें और प्रिंट करें: कॉपी सपोर्ट के साथ मूल प्रारूप में अनुवाद डाउनलोड करें।',
      download: 'डाउनलोड करना',
      downloadMsg1: 'पीडीएफ अनुवाद प्रगति:',
      downloadMsg2: 'अनुमानित शेष समय:',
      downloadSucc: 'पीडीएफ तैयार है! सहेजने के लिए क्लिक करें।',
      downloadTip: 'पीडीएफ डाउनलोड करना। डाउनलोड त्रुटियों से बचने के लिए इस विंडो को बंद न करें।',
      error: 'बचाने में विफल रहा। इसके बजाय छपाई का प्रयास करें।',
      fileName: 'ERROR: [File Name:]',
      fileType: 'ERROR: [File Type:]',
      loading: 'बचत ...',
      loading2: 'लोड हो रहा है ...',
      minute: 'मिनट...',
      msg1: 'इस दस्तावेज़ में कुछ अनुवाद मूल पाठ की तुलना में लंबे हैं, और डाउनलोड की गई फ़ाइल में ओवरलैप हो सकते हैं। हम वेबपेज पर पढ़ने की सलाह देते हैं।',
      msg2: '1। अनुवाद अभी तक पूरा नहीं हुआ है। अनुवाद समाप्त होने के बाद कृपया डाउनलोड करें।',
      msg3: '2। कुछ अनुवाद बहुत लंबे हैं। टेक्स्ट ओवरलैप से बचने के लिए वेबपेज पर पढ़ें।',
      msg4: 'अनुवाद कार्य प्रगति पर हैं। कृपया पूरा होने के बाद कृपया प्रयास करें।',
      progress: 'अनुवाद पीडीएफ। प्रगति: {{प्रगति}}, अनुमानित समय शेष: {{मिनट}} मिनट ...',
      save: 'डिवाइस को सहेजें',
      savePrint: 'सहेजें और प्रिंट करें',
      success: 'डाउनलोड',
      trans: 'ERROR: [Translation Only]',
      transContinue: 'अनुवाद जारी रखें',
    },
    downloadBtn: 'डाउनलोड करना',
    dragTipModal: {
      black: 'अंतरिक्ष',
      leftKey: 'वाम बटन',
      ok: 'समझ गया',
      press: 'प्रेस',
      tips: 'खींचें और देखने के लिए।',
    },
    entry: 'पीडीएफ़',
    fileErrMsg: 'फ़ाइल पढ़ना विफल रहा। कृपया बाद में पुनः प्रयास करें, या समर्थन से संपर्क करें।',
    fileMsg: 'वर्तमान फ़ाइल आकार:',
    fileMsg2: 'कृपया 300MB से छोटी फ़ाइल अपलोड करें।',
    freeBannerBtn: 'उन्नत करना',
    freeBannerTips: 'नि: शुल्क पीडीएफ अनुवाद सीमा तक पहुंच गई',
    guide: {
      placeholder: 'यहां पीडीएफ लिंक पेस्ट करें',
      start: 'अनुवाद करना शुरू करें',
      text1: 'द्विभाषी पठन',
      text2: 'मूल पाठ और अनुवाद की तुलना करने के लिए द्विभाषी पढ़ें, अपनी दक्षता में सुधार करें।',
      text3: 'अपने पीडीएफ के साथ चैट करें',
      text4:
        'एआई-संचालित विश्लेषण और सारांश। अपने पीडीएफ के बारे में प्रश्न पूछें, और तत्काल उत्तर प्राप्त करें।',
      text5: 'सटीक और कुशल',
      text6: 'अधिक सटीकता और दक्षता के लिए एआई-संचालित पीडीएफ अनुवाद।',
      title1: 'द्विभाषी अनुवाद',
      title2: 'अपने पीडीएफ के साथ चैट करें',
      toast: 'कृपया .pdf में एक मान्य ऑनलाइन पीडीएफ लिंक दर्ज करें',
    },
    hasTransTask: 'एक अनुवाद कार्य प्रगति पर है। कृपया प्रतीक्षा करें।',
    hoverTrans: 'होवर-टू-ट्रांसलेट पैराग्राफ',
    initial: 'अनुवाद पीडीएफ',
    installText: 'रोजमर्रा के अनुवादों के लिए आपका वन-स्टॉप समाधान।',
    installText2: 'कृपया पहले एक्सटेंशन इंस्टॉल करें',
    installTips:
      'और भी अधिक पीडीएफ अनुवादों के लिए एक्सटेंशन स्थापित करें, और स्मूथ वेबसाइट अनुवाद:',
    kw: 'प्रधान',
    link: 'जोड़ना',
    listError:
      'पीडीएफ लोड करने में विफल। कृपया बाद में पुनः प्रयास करें, या समर्थन से संपर्क करें।',
    memoTotalCount: '1 आइटम कुल',
    new: 'नई फ़ाइल',
    noId: 'फ़ाइल आईडी नहीं मिली।',
    notPdf: 'केवल पीडीएफ फाइलें।',
    okBtn: 'मिटाना',
    okBtn2: 'समझ गया',
    original: 'मूल',
    parallel: 'समानांतर',
    parseErrDialogContent:
      'इस पीडीएफ लिंक का सीधे अनुवाद नहीं किया जा सकता है। कृपया पीडीएफ डाउनलोड करें और इसे अनुवाद के लिए अपलोड करें।',
    parseErrTips: 'फ़ाइल को पार्स करने में विफल',
    parseFileToast:
      'फ़ाइल को पार्स करने में विफल रहा। कृपया बाद में पुनः प्रयास करें, या समर्थन से संपर्क करें।',
    pdfLoading: 'पार्सिंग ...',
    searchPlaceholder: 'खोज',
    selectTrans: 'अनुवाद करने के लिए पाठ का चयन करें',
    shareBtn: 'शेयर करना',
    shareBtnText1: 'शेयर लिंक उत्पन्न करें',
    shareBtnText2: 'साझा सामग्री अद्यतन करें',
    shareModal: {
      cancel: 'रद्द करना',
      copy: 'प्रतिलिपि',
      copySucc: 'लिंक कॉपी किया गया',
      custom: 'अनुकूलित करें:',
      errMsg:
        'चयनित सामग्री को अभी तक पूरी तरह से अनुवादित नहीं किया गया है। कृपया साझा करने से पहले अनुवाद करें।',
      gen: 'शेयर करना',
      modify: 'संपादन करना',
      notSupport: 'यह भाषा वर्तमान में समर्थित नहीं है।',
      page: 'पृष्ठों',
      pageNuErr: 'कृपया एक मान्य पृष्ठ संख्या दर्ज करें।',
      range: 'दायरा:',
      remain: 'शेष',
      remain1: 'कुल अनुमानित समय:',
      search: 'खोज',
      settings: 'शेयर सेटिंग्स:',
      shareSetting: 'शेयर सेटिंग्स',
      shareText: 'शेयर करना',
      shareTips: 'अपने दोस्तों के साथ अनुवादित पीडीएफ लिंक साझा करें:',
      sourceLang: 'से:',
      target: 'को:',
      text1: 'शेयर सेटिंग्स',
      text2: 'शेयर लिंक उत्पन्न करें',
      totalPage: '1 पृष्ठ कुल',
      trans: 'अनुवाद',
      translateTips:
        'टिप: यदि अनुवाद में थोड़ी देर लग रही है, तो आप इस विंडो को बंद कर सकते हैं और बाद में साझा कर सकते हैं।',
      translating: 'अनुवाद पीडीएफ ...',
      update: 'अद्यतन शेयर लिंक',
    },
    shareMsg1: 'साझा लिंक उत्पन्न।',
    shareMsg2: 'साझा सामग्री अपडेट की गई।',
    shareMsg3:
      'शेयर लिंक उत्पन्न करने में विफल। कृपया बाद में पुनः प्रयास करें, या समर्थन से संपर्क करें।',
    shareMsg4:
      'साझा सामग्री को अपडेट करने में विफल। कृपया बाद में पुनः प्रयास करें, या समर्थन से संपर्क करें।',
    shareTips: 'आपका पीडीएफ अनुवाद तैयार है! इसे अपने दोस्तों के साथ साझा करें।',
    start: 'अपना नि: शुल्क परीक्षण शुरू करो',
    thumbnail: 'विषयसूची',
    toast1: 'लोडिंग पीडीएफ। कृपया बाद में पुन: प्रयास करें।',
    toast2: 'पीडीएफ सामग्री बहुत बड़ी है। संवाद वर्तमान में असमर्थित है।',
    toast3: 'डाउनलोडिंग। डाउनलोड समाप्त होने के बाद कृपया पुनः प्रयास करें।',
    toolbar: { Adjust: 'समायोजित करना', autoFit: 'स्वत: फ़िट' },
    trans: 'अनुवाद',
    transSucc: 'अनुवाद सफल!',
    unLoginToast: 'इस विशेष सुविधा का प्रयोग करने के लिए लॉग इन करें।',
    uploadBtn: 'अपलोड करना',
    uploadErr: 'फ़ाइल अपलोड विफल। कृपया बाद में पुनः प्रयास करें, या समर्थन से संपर्क करें।',
    uploadErrSignUrl:
      'URL अपलोड करने में विफल रहा। कृपया बाद में पुनः प्रयास करें, या समर्थन से संपर्क करें।',
    uploadMsg1: 'अपनी फ़ाइल को यहां खींचें और ड्रॉप करें।',
    uploadMsg2: 'समर्थित फ़ाइल प्रकार: पीडीएफ |  अधिकतम फ़ाइल का आकार: 300MB',
    uploadMsg3: 'फ़ाइलों को चुनने या खींचने और ड्रॉप करने के लिए क्लिक करें।',
    uploading: 'अपलोड हो रहा है',
    uploadingMsg: 'अपलोड करना। कृपया प्रतीक्षा करें।',
    uploadingMsg1: 'फ़ाइल अपलोड कर रही है। कृपया बाद में पुन: प्रयास करें।',
    uploadingMsg2: 'वर्तमान में एक फ़ाइल परिवर्तित की जा रही है। कृपया बाद में पुन: प्रयास करें।',
    uploadingMsg3:
      'रूपांतरण प्रगति अनुरोध विफल रहा। कृपया बाद में पुनः प्रयास करें, या समर्थन से संपर्क करें।',
    uploadingMsg4:
      'NOAM स्थानीय फ़ाइलों तक नहीं पहुंच सकता है। कृपया अनुवाद के लिए मैन्युअल रूप से एक पीडीएफ अपलोड करें।',
    uploadingMsg5:
      'फ़ाइल URL को पुनः प्राप्त करने में विफल। कृपया बाद में पुनः प्रयास करें, या समर्थन से संपर्क करें।',
    video: 'वीडियो',
    vipBannerBtn: 'उन्नत करना',
    vipBannerTips: 'आप इस महीने के लिए अपनी पीडीएफ अनुवाद सीमा तक पहुंच गए हैं।',
    webTrans: 'पूर्ण क्रॉस-संदर्भ',
  },
  pricing: {
    FAQ: 'उपवास',
    FQAObj: {
      a1: 'हां, NOAM एक मुफ्त योजना प्रदान करता है जिसका आप तुरंत उपयोग कर सकते हैं।',
      a2: 'हम तीन सदस्यता योजनाएं प्रदान करते हैं: प्रो, प्रो+, और एंटरप्राइज। आप मासिक या सालाना भुगतान करना चुन सकते हैं। वार्षिक बिलिंग महत्वपूर्ण बचत प्रदान करता है।',
      a3: 'सभी सुविधाएँ दोनों योजनाओं पर उपलब्ध हैं। मुख्य अंतर लागत है: वार्षिक सदस्यता कुल मिलाकर कम है। मासिक सदस्यता प्रत्येक महीने बिल दी जाती है, जबकि वार्षिक योजनाओं को प्रति वर्ष एक बार बिल दिया जाता है।',
      a4: 'आप अपनी खाता सेटिंग में कभी भी अपनी सदस्यता रद्द कर सकते हैं।',
      q1: 'क्या कोई मुफ्त योजना है?',
      q2: 'क्या मूल्य निर्धारण योजनाएं और भुगतान विकल्प उपलब्ध हैं?',
      q3: 'मासिक बनाम सालाना सदस्यता के बीच क्या अंतर है?',
      q4: 'मैं अपना सबस्क्रिप्शन कैसे रद्द करूं?',
    },
    around: 'आस-पास',
    billedMonthly: 'मंथली बिल',
    billedYearly: 'सालाना बिल',
    day: 'दिन',
    desc: 'योजनाओं की तुलना करें और सबसे अच्छा चुनें',
    detailedCompare: 'योजनाओं की तुलना करें',
    discount: '20% की छूट',
    enterprise: {
      benefit1: 'प्राथमिकता ग्राहक सहायता',
      benefit2: 'कई उपयोगकर्ता',
      benefit3: 'अनुरूप समाधान',
      benefit5: 'समर्पित खाता प्रबंधक',
      btn: 'हमसे संपर्क करें',
      recommendText: 'कस्टम योजनाएं （≥3））',
      talkToUs: 'संपर्क में रहो',
    },
    free: {
      benefit1: 'तत्काल अनुवाद 100 बार/दिन',
      benefit2: 'वेबसाइट अनुवाद और सारांश',
      benefit3: '30 छवि अनुवाद',
      benefit4: 'वीडियो अनुवाद और सारांश',
      benefit5: '10 पीडीएफ अनुवाद',
      benefit6: '5,000 टोकन',
      btn: 'मुफ्त में आजमाएं',
      recommendText: 'मुफ्त परीक्षण',
    },
    imageTranslation: 'छवि अनुवाद',
    month: 'महीना',
    monthly: 'महीने के',
    pageTitle: 'मूल्य निर्धारण',
    pdf: {
      chat: 'पीडीएफ चैट क्वेरीज़',
      maxPage: 'अधिकतम। पेज प्रति पीडीएफ',
      translation: 'पीडीएफ अनुवाद',
    },
    preMonth: 'प्रति महीने',
    pro: {
      benefit1: 'प्राथमिकता ग्राहक सहायता',
      benefit2: '1,000,000 टोकन/महीना',
      benefit3: 'वेबसाइट अनुवाद और सारांश',
      benefit4: '200 छवि अनुवाद',
      benefit5: 'वीडियो अनुवाद और सारांश',
      benefit6: '200 पीडीएफ अनुवाद',
      btn: 'शुरू हो जाओ',
      recommendText: 'सबसे लोकप्रिय',
    },
    proPlus: {
      benefit1: 'प्राथमिकता ग्राहक सहायता',
      benefit2: 'ERROR: [3,000,000 tokens/month]',
      benefit3: 'वेबसाइट अनुवाद और सारांश',
      benefit4: '500 छवि अनुवाद',
      benefit5: 'वीडियो अनुवाद और सारांश',
      benefit6: '500 पीडीएफ अनुवाद',
      recommendText: 'सबसे अच्छा मूल्य',
    },
    video: { summary: 'वीडियो सारांश', translation: 'वीडियो अनुवाद' },
    web: {
      contrastiveTranslation: 'द्विभाषी अनुवाद',
      dictionaryTranslation: 'चयन अनुवाद',
      hoverTranslation: 'होवर अनुवाद',
      instantTranslation: 'तुरंत अनुवाद',
      summary: 'वेब पृष्ठ सारांश',
    },
    yearly: 'सालाना',
  },
  privacy: {
    block1:
      'नोआम ("नोआम," "हम," "हमारा," या "हम") आपकी गोपनीयता का सम्मान करता है और हम आपसे या आपके बारे में प्राप्त की जाने वाली किसी भी जानकारी को बचाने के लिए प्रतिबद्ध है। यह गोपनीयता नीति हमारी वेबसाइट, अनुप्रयोगों और सेवाओं (सामूहिक रूप से, "सेवाओं") के उपयोग से व्यक्तिगत जानकारी के संग्रह या उपयोग के बारे में हमारी प्रथाओं का वर्णन करती है। यह गोपनीयता नीति हमारे व्यावसायिक उत्पाद ग्राहकों की ओर से हमारे द्वारा संभाल की गई सामग्री पर लागू नहीं होती है, जैसे कि हमारे एपीआई। इस डेटा का उपयोग हमारे ग्राहक समझौते के अधीन है, जो इन उत्पादों की पहुंच और उपयोग को कवर करता है।',
    block10:
      'हम ऑनलाइन और ऑफलाइन व्यक्तिगत जानकारी को नुकसान, दुरुपयोग और अनधिकृत पहुंच, प्रकटीकरण, परिवर्तन, या शत्रुतापूर्ण कृत्यों से ऑनलाइन और ऑफलाइन व्यक्तिगत जानकारी की रक्षा के लिए व्यावसायिक रूप से उचित तकनीकी, प्रशासनिक और संगठनात्मक उपायों को लागू करते हैं। हालांकि, कोई भी इंटरनेट या ईमेल ट्रांसमिशन पूर्ण सुरक्षा या सटीकता की गारंटी नहीं दे सकता है। विशेष रूप से, हमें या हमें भेजे गए ईमेल सुरक्षित नहीं हो सकते हैं। इसलिए, सेवा या ईमेल के माध्यम से हमें क्या जानकारी भेजना है, यह तय करते समय आपको विशेष रूप से सावधान रहना चाहिए। इसके अतिरिक्त, हम सेवा या तीसरे पक्ष की वेबसाइटों की सुरक्षा सेटिंग्स या सुरक्षा उपायों में गोपनीयता सेटिंग्स या सुरक्षा उपायों की किसी भी बाधा के लिए जिम्मेदार नहीं हैं। हम आपकी व्यक्तिगत जानकारी को तब तक बनाए रखेंगे जब तक कि हमें सेवाएं प्रदान करने के लिए या अन्य वैध व्यावसायिक उद्देश्यों के लिए, जैसे विवाद, सुरक्षा और सुरक्षा कारणों को हल करना, या हमारे कानूनी दायित्वों का अनुपालन करना होगा। व्यक्तिगत जानकारी को बनाए रखने के समय की लंबाई कई कारकों पर निर्भर करेगी, जैसे कि राशि, प्रकृति, जानकारी की संवेदनशीलता, अनधिकृत उपयोग या प्रकटीकरण के संभावित जोखिम, वे उद्देश्य जिनके लिए हम सूचना को संसाधित करते हैं, और अन्य कानूनी रूप से बाध्यकारी विचार।',
    block11:
      'हम समय -समय पर इस गोपनीयता नीति को अपडेट कर सकते हैं। जब हम ऐसा करते हैं, तो हम इस पृष्ठ पर एक अद्यतन संस्करण पोस्ट करेंगे, जब तक कि लागू कानून द्वारा अन्यथा आवश्यक नहीं है।',
    block12:
      'यदि आपके पास इस गोपनीयता नीति के बारे में कोई अनुत्तरित प्रश्न या चिंता है, तो कृपया हमारी ग्राहक सेवा से संपर्क करें। ईमेल:',
    block2: 'हम आपसे संबंधित व्यक्तिगत जानकारी ("व्यक्तिगत जानकारी") एकत्र करते हैं:',
    block3:
      'आपके द्वारा दी गई जानकारी: जब आप हमारी सेवाओं का उपयोग करने या हमारे साथ संवाद करने के लिए एक खाता बनाते हैं, तो हम व्यक्तिगत जानकारी इस प्रकार एकत्र करते हैं:',
    block4:
      'सेवाओं के आपके उपयोग से स्वचालित रूप से प्राप्त व्यक्तिगत जानकारी: जब आप सेवाओं के साथ उपयोग, उपयोग या बातचीत करते हैं, तो हम आपकी पहुंच, उपयोग या बातचीत के बारे में निम्नलिखित जानकारी प्राप्त करते हैं ("तकनीकी जानकारी"):',
    block5: 'हम निम्नलिखित उद्देश्यों के लिए व्यक्तिगत जानकारी का उपयोग कर सकते हैं:',
    block6:
      'सारांश या डी-पहचान की गई जानकारी: हम पहचान के उद्देश्यों के लिए इसके पुन: उपयोग को रोकने के लिए व्यक्तिगत जानकारी को एकत्र या डी-पहचान कर सकते हैं और हमारी सेवाओं की प्रभावशीलता का विश्लेषण करने, हमारी सेवाओं में सुविधाओं को सुधारने और जोड़ने, अनुसंधान का संचालन करने और समान उद्देश्यों के लिए इस तरह की जानकारी का उपयोग कर सकते हैं। इसके अतिरिक्त, हम अपने सेवा उपयोगकर्ताओं के सामान्य व्यवहार और विशेषताओं का विश्लेषण कर सकते हैं और तृतीय पक्षों के साथ एकत्रित जानकारी साझा कर सकते हैं, ऐसी एकत्रित जानकारी प्रकाशित कर सकते हैं, या इसे आम तौर पर उपलब्ध करा सकते हैं। हम सेवाओं के माध्यम से, कुकीज़ के माध्यम से, और इस गोपनीयता नीति में वर्णित अन्य साधनों के माध्यम से एकत्रित जानकारी एकत्र कर सकते हैं। हम एक अनाम या डी-पहचान किए गए रूप में डी-पहचान की गई जानकारी को बनाए रखेंगे और उसका उपयोग करेंगे, और जब तक कानून द्वारा आवश्यक हो, हम ऐसी जानकारी को फिर से पहचानने का प्रयास नहीं करेंगे।',
    block7:
      'कुछ मामलों में, हम आपकी व्यक्तिगत जानकारी तीसरे पक्ष को बिना किसी नोटिस के प्रदान कर सकते हैं, जब तक कि कानून द्वारा आवश्यक हो:',
    block8:
      'आपके भौगोलिक स्थिति के आधार पर, यूरोपीय आर्थिक क्षेत्र में व्यक्तियों, यूनाइटेड किंगडम और विश्व स्तर पर उनकी व्यक्तिगत जानकारी के बारे में कुछ वैधानिक अधिकार हो सकते हैं। उदाहरण के लिए, आपके पास अधिकार हो सकता है:',
    block9:
      'इस सेवा में सोशल मीडिया सेवाओं ("थर्ड पार्टी वेबसाइट्स" ") सहित NOAM द्वारा संचालित या नियंत्रित नहीं की गई अन्य वेबसाइटों के लिंक हो सकते हैं। तीसरे पक्ष की वेबसाइटों के साथ आपके द्वारा साझा की जाने वाली जानकारी विशिष्ट गोपनीयता नीतियों और तीसरे पक्ष की वेबसाइटों की सेवा की शर्तों द्वारा शासित होगी, न कि इस गोपनीयता नीति द्वारा। हम सुविधा के लिए ये लिंक प्रदान करते हैं और इन वेबसाइटों की हमारी समर्थन या समीक्षा नहीं करते हैं। कृपया उनकी गोपनीयता नीतियों और शर्तों के बारे में जानकारी के लिए सीधे तीसरे पक्ष की वेबसाइटों से संपर्क करें।',
    subBlock1:
      'खाता जानकारी: जब आप हमारे प्लेटफ़ॉर्म पर कोई खाता बनाते हैं, तो हम आपके खाते से संबंधित जानकारी एकत्र करते हैं, जिसमें आपका नाम, संपर्क जानकारी, खाता क्रेडेंशियल्स, भुगतान कार्ड की जानकारी और लेनदेन इतिहास ("खाता जानकारी") शामिल हैं।',
    subBlock10: 'सेवाओं को प्रदान करना, प्रबंधित करना, रखरखाव और/या विश्लेषण करना;',
    subBlock11: 'आपके साथ संवाद करना;',
    subBlock12: 'नए उत्पादों और सेवाओं को विकसित करना;',
    subBlock13:
      'धोखाधड़ी, आपराधिक गतिविधि, या हमारी सेवाओं का दुरुपयोग, और हमारे आईटी सिस्टम, वास्तुकला और नेटवर्क की सुरक्षा की रक्षा करना;',
    subBlock14: 'व्यापार स्थानान्तरण का संचालन करना;',
    subBlock15:
      'कानूनी दायित्वों और कानूनी कार्यवाही का अनुपालन करना, हमारे अधिकारों, गोपनीयता, सुरक्षा, या संपत्ति की रक्षा करना, साथ ही साथ हमारे सहयोगियों, आप, या अन्य तृतीय पक्षों।',
    subBlock16:
      'आपूर्तिकर्ताओं और सेवा प्रदाता: व्यावसायिक परिचालन आवश्यकताओं को पूरा करने और कुछ सेवाओं और कार्यों को पूरा करने में हमारी सहायता करने के लिए, हम आपूर्तिकर्ताओं और सेवा प्रदाताओं को व्यक्तिगत जानकारी प्रदान कर सकते हैं, जिसमें सेवा प्रदाताओं, क्लाउड सेवा प्रदाताओं, और अन्य सूचना प्रौद्योगिकी सेवा प्रदाताओं, ईमेल संचार सॉफ्टवेयर, और वेब एनालिटिक्स सेवा प्रदाता, आदि शामिल हैं, जो कि हमारे निर्देशन में व्यक्तिगत जानकारी के लिए व्यक्तिगत जानकारी प्राप्त करेंगे।',
    subBlock17:
      'व्यावसायिक स्थानान्तरण: यदि हम रणनीतिक लेनदेन, पुनर्गठन, दिवालियापन, दिवालियापन के अधिग्रहण, या किसी अन्य प्रदाता (सामूहिक रूप से, "लेनदेन") के लिए सेवाओं के संक्रमण में संलग्न हैं, तो आपकी व्यक्तिगत जानकारी और अन्य जानकारी लेनदेन समकक्षों और अन्य पक्षों के साथ साझा की जा सकती है, जो कि अन्य परिसंपत्तियों के साथ लेनदेन में सहायता कर रहे हैं और अन्य परिसंपत्तियों के साथ एक भाग के रूप में स्थानांतरित कर सकते हैं।',
    subBlock18:
      'कानूनी आवश्यकताएँ: हम आपकी व्यक्तिगत जानकारी को सरकारी अधिकारियों, उद्योग साथियों, या अन्य तृतीय पक्षों के साथ साझा कर सकते हैं, जिसमें हमारी सेवाओं के साथ आपकी बातचीत की जानकारी शामिल है, (1) यदि आवश्यक हो या यदि हम मानते हैं कि कानूनी दायित्वों का पालन करने के लिए ऐसी कार्रवाई आवश्यक है; (२) हमारे अधिकारों या संपत्ति की रक्षा और बचाव करना; (३) यदि हम एकतरफा रूप से यह निर्धारित करते हैं कि हमारी शर्तों, नीतियों या कानूनों का उल्लंघन है; (4) धोखाधड़ी या अन्य अवैध गतिविधियों का पता लगाने या रोकने के लिए; (५) हमारे उत्पादों, कर्मचारियों, या उपयोगकर्ताओं, या सार्वजनिक सुरक्षा, सुरक्षा, अखंडता की रक्षा करना; या (vi) कानूनी देयता के खिलाफ बचाव करने के लिए।',
    subBlock19:
      'अपनी व्यक्तिगत जानकारी और जानकारी के बारे में जानकारी प्राप्त करें कि यह कैसे संसाधित होता है।',
    subBlock2:
      'उपयोगकर्ता सामग्री: जब आप हमारी सेवाओं का उपयोग करते हैं, तो हम आपके इनपुट, फ़ाइल अपलोड, या हमें प्रदान की गई प्रतिक्रिया ("सामग्री") से व्यक्तिगत जानकारी एकत्र करते हैं।',
    subBlock20: 'हमारे रिकॉर्ड से आपकी व्यक्तिगत जानकारी को हटाने का अनुरोध करें।',
    subBlock21: 'अपनी व्यक्तिगत जानकारी को सही या अपडेट करें।',
    subBlock22:
      'अपनी व्यक्तिगत जानकारी को किसी तीसरे पक्ष (डेटा पोर्टेबिलिटी) में स्थानांतरित करें।',
    subBlock23: 'सीमित करें कि हम आपकी व्यक्तिगत जानकारी को कैसे संसाधित करते हैं।',
    subBlock24:
      'अपनी सहमति वापस लें - जहां हम प्रसंस्करण के लिए कानूनी आधार के रूप में सहमति पर भरोसा करते हैं, आप किसी भी समय अपनी सहमति वापस ले सकते हैं।',
    subBlock25: 'आप आपकी व्यक्तिगत जानकारी को कैसे संसाधित करते हैं, इस पर आपत्ति जताएं।',
    subBlock26: 'हमारी सेवाओं में सुधार और अनुसंधान का संचालन करना;',
    subBlock3:
      'संचार जानकारी: यदि आप हमें संदेश भेजते हैं, तो हम आपका नाम, संपर्क जानकारी और आपके संदेशों की सामग्री ("संचार जानकारी") एकत्र करेंगे।',
    subBlock4:
      'सोशल मीडिया की जानकारी: हमारे पास सोशल मीडिया वेबसाइटों जैसे कि इंस्टाग्राम, फेसबुक, मीडियम, ट्विटर, यूट्यूब और लिंक्डइन पर पेज हैं। जब आप हमारे सोशल मीडिया पेजों के साथ बातचीत करते हैं, तो हम उस व्यक्तिगत जानकारी को एकत्र करते हैं जिसे आप हमें प्रदान करने के लिए चुनते हैं, जैसे कि आपका संपर्क विवरण ("सामाजिक जानकारी")। इसके अतिरिक्त, हमारे सोशल मीडिया पेजों की मेजबानी करने वाली कंपनियां हमें हमारी सोशल मीडिया गतिविधियों के बारे में एकत्रित जानकारी और विश्लेषण प्रदान कर सकती हैं।',
    subBlock5:
      'लॉग डेटा: हमारी सेवाओं का उपयोग करते समय अपने ब्राउज़र द्वारा स्वचालित रूप से भेजी गई जानकारी। लॉग डेटा में आपका इंटरनेट प्रोटोकॉल (आईपी) पता, ब्राउज़र प्रकार और सेटिंग्स, आपके अनुरोधों की दिनांक और समय और आप हमारी वेबसाइट के साथ कैसे बातचीत करते हैं।',
    subBlock6:
      'उपयोग डेटा: हम स्वचालित रूप से सेवा के आपके उपयोग के बारे में जानकारी एकत्र कर सकते हैं, जैसे कि आप जिस प्रकार की सामग्री देख रहे हैं या उसके साथ बातचीत करते हैं, आपके द्वारा उपयोग की जाने वाली विशेषताएं, आपके द्वारा ली जाने वाली क्रियाएं, साथ ही साथ आपका समय क्षेत्र, देश, दिनांक और एक्सेस का समय, उपयोगकर्ता एजेंट और संस्करण, कंप्यूटर या मोबाइल डिवाइस प्रकार, और आपका कंप्यूटर कनेक्शन।',
    subBlock7:
      'डिवाइस की जानकारी: इसमें डिवाइस का नाम, ऑपरेटिंग सिस्टम, डिवाइस पहचानकर्ता और आपके द्वारा उपयोग किए जा रहे ब्राउज़र शामिल हैं। एकत्र की गई जानकारी आपके द्वारा उपयोग किए जा रहे डिवाइस के प्रकार और इसकी सेटिंग्स पर निर्भर हो सकती है।',
    subBlock8:
      'कुकीज़: हम अपनी सेवाओं को संचालित करने और प्रबंधित करने और अपने अनुभव को बेहतर बनाने के लिए कुकीज़ का उपयोग करते हैं। एक "कुकी" एक वेबसाइट द्वारा भेजी गई जानकारी है जिसे आप अपने ब्राउज़र पर जाते हैं। आप सभी कुकीज़ को स्वीकार करने के लिए अपने ब्राउज़र को सेट कर सकते हैं, सभी कुकीज़ को अस्वीकार कर सकते हैं, या आपको सूचित कर सकते हैं जब एक कुकी प्रदान की जाती है ताकि आप यह तय कर सकें कि इसे हर बार स्वीकार करना है या नहीं। हालांकि, कुकीज़ से इनकार करने से आपको वेबसाइट के कुछ क्षेत्रों या सुविधाओं के प्रदर्शन या कार्यक्षमता का उपयोग करने या नकारात्मक रूप से प्रभावित करने से रोक सकता है। कुकीज़ के बारे में अधिक जानकारी के लिए, कृपया कुकीज़ के बारे में सभी पर जाएँ।',
    subBlock9:
      'एनालिटिक्स: हम विभिन्न ऑनलाइन एनालिटिक्स उत्पादों का उपयोग कर सकते हैं जो कुकीज़ का उपयोग करते हैं ताकि हमें यह विश्लेषण करने में मदद मिल सके कि उपयोगकर्ता हमारी सेवाओं का उपयोग कैसे करते हैं और सेवाओं का उपयोग करते समय अपने अनुभव में सुधार करते हैं।',
    subTitle1: 'व्यक्तिगत जानकारी जो हम एकत्र करते हैं',
    subTitle2: 'हम व्यक्तिगत जानकारी का उपयोग कैसे करते हैं',
    subTitle3: 'व्यक्तिगत जानकारी का प्रकटीकरण',
    subTitle4: 'आपके हक',
    subTitle5: 'अन्य वेब साइटों के लिंक',
    subTitle6: 'सूचना और सूचनाओं की अवधारण',
    subTitle7: 'गोपनीयता नीति में संशोधन',
    subTitle8: 'हम से कैसे संपर्क करें',
    title: 'गोपनीयता नीति',
    updateTime: 'अद्यतन: 15 मार्च, 2024',
  },
  privacyCollectionPanel: {
    acceptBtn: 'सभी स्वीकृत',
    text: 'अपने अनुभव को बेहतर बनाने के लिए, हम सामग्री और सेवाओं को निजीकृत करने के लिए कुकीज़ का उपयोग करते हैं।',
    title: 'यह वेबसाइट कुकीज़ का उपयोग करती है',
  },
  slogen: 'सबसे आसान एआई सहायक',
  stripe: {
    contact: 'किसी भी प्रश्न के साथ contact@noam.tools पर हमसे संपर्क करें!',
    fail: {
      btn: 'पुन: प्रयास करें',
      text1: 'हम आपके भुगतान को संसाधित नहीं कर सके।',
      text2: 'अपने कनेक्शन की जाँच करें और फिर से प्रयास करें।',
      title: 'भुगतान विफल रही',
    },
    succ: {
      btn: 'चल दर',
      text1: 'NOAM में आपका स्वागत है,',
      text2: 'आएँ शुरू करें!',
      title: 'बधाई हो',
    },
  },
  terms: {
    block1: 'NOAM का उपयोग करने के लिए धन्यवाद!',
    block10:
      '(ए) शुल्क और बिलिंग। आप लागू मूल्य निर्धारण पृष्ठ पर मूल्य निर्धारण और शर्तों के अनुसार सभी शुल्क ("शुल्क") का भुगतान करेंगे या जैसा कि हमारे बीच लिखित रूप में सहमत हैं। हम मूल्य निर्धारण त्रुटियों या गलतियों को सही करने का अधिकार सुरक्षित रखते हैं, भले ही हमने चालान जारी किया हो या भुगतान प्राप्त किया हो। आप एक वैध और अधिकृत भुगतान विधि सहित पूर्ण और सटीक बिलिंग जानकारी प्रदान करेंगे। हम आपकी भुगतान विधि को आवधिक आधार पर चार्ज करेंगे, जैसा कि सहमत है, लेकिन हम बिलिंग की तारीख को यथोचित रूप से बदल सकते हैं। आप अपनी भुगतान विधि को चार्ज करने के लिए NOAM, इसके सहयोगियों और तीसरे पक्ष के भुगतान प्रोसेसर को अधिकृत करते हैं। यदि आपका भुगतान विफल हो जाता है, तो हम आपको लिखित नोटिस प्रदान करेंगे और भुगतान प्राप्त होने तक सेवा तक पहुंच को निलंबित कर सकते हैं। इस समझौते में अन्यथा निर्दिष्ट के अलावा, भुगतान गैर-वापसी योग्य हैं।',
    block11:
      '(b) कर। जब तक अन्यथा नहीं कहा जाता है, फीस में कोई संघीय, राज्य, स्थानीय और विदेशी कर, कर्तव्यों और इसी तरह के आकलन ("कर") शामिल नहीं हैं। आप अपनी खरीद से जुड़े सभी करों के लिए जिम्मेदार हैं, हमारी शुद्ध आय के आधार पर करों को छोड़कर, जिसके लिए हम आपको चालान करेंगे। आप इस तरह के करों का तुरंत भुगतान करने के लिए सहमत हैं और हमें कानूनी रूप से वैध गोपनीयता विवरण प्रदान करते हैं और इस तरह के डेटा को संभालने के लिए आवश्यक सहमति प्राप्त करते हैं, और आप हमें वारंट करते हैं कि आप लागू कानून के अनुसार ऐसे डेटा को संभालते हैं।',
    block12:
      '(c) मूल्य परिवर्तन। हम आपके खाते और/या हमारी वेबसाइट के माध्यम से आपको सूचित करके अपनी कीमतें बदल सकते हैं। पोस्टिंग पर तुरंत मूल्य वृद्धि प्रभावी होगी। परिवर्तन की प्रभावी तिथि के बाद आपके खाते के लिए कोई भी मूल्य परिवर्तन लागू होगा।',
    block13:
      '(d) विवाद और अतिदेय भुगतान। यदि आप किसी भी शुल्क या करों पर विवाद करना चाहते हैं, तो कृपया चालान की तारीख के तीस (30) दिनों के भीतर संपर्क@noam.tools से संपर्क करें।',
    block14:
      '(ई) मुफ्त उपयोग। आप मुफ्त क्रेडिट प्राप्त करने के लिए कई खाते नहीं बना सकते हैं। यदि हम यह निर्धारित करते हैं कि आप अच्छे विश्वास में मुफ्त क्रेडिट का उपयोग नहीं कर रहे हैं, तो हम आपको मानक शुल्क ले सकते हैं या सेवा तक पहुंच प्रदान करना बंद कर सकते हैं।',
    block15:
      '(ए) गोपनीयता। आपके पास NOAM की गोपनीय जानकारी तक पहुंच हो सकती है। आप सेवा का उपयोग करने के उद्देश्य से इन शर्तों के तहत केवल गोपनीय जानकारी का उपयोग कर सकते हैं। आप किसी भी तीसरे पक्ष को गोपनीय जानकारी का खुलासा नहीं कर सकते हैं, और आप गोपनीय जानकारी की रक्षा करेंगे, जिस तरह से आप अपनी समान गोपनीय जानकारी की रक्षा करते हैं, कम से कम उचित देखभाल के साथ। गोपनीय जानकारी गैर-सार्वजनिक जानकारी है जिसे NOAM द्वारा गोपनीय के रूप में नामित किया गया है या जिसे उचित रूप से सॉफ्टवेयर, विनिर्देशों और अन्य गैर-सार्वजनिक व्यावसायिक जानकारी सहित परिस्थितियों में गोपनीय माना जाना चाहिए। गोपनीय जानकारी में जानकारी शामिल नहीं है कि: (1) आम तौर पर आपकी ओर से गलती के बिना जनता के लिए उपलब्ध हो जाता है; (२) इन शर्तों के तहत इसे प्राप्त करने से पहले गोपनीयता के किसी भी दायित्व के बिना आपके कब्जे में था; (३) किसी भी गोपनीयता दायित्वों के बिना किसी तीसरे पक्ष द्वारा आपको विधिपूर्वक प्रकट किया गया है; या (4) गोपनीय जानकारी का उपयोग किए बिना आपके द्वारा स्वतंत्र रूप से विकसित किया गया है। यदि आप कानून, अदालत, या अन्य सरकारी आदेश द्वारा आवश्यक हो तो गोपनीय जानकारी का खुलासा कर सकते हैं, लेकिन आपको उचित तरीके से एनओएएम को पूर्व लिखित नोटिस प्रदान करना होगा और संभव हो, प्रकटीकरण के दायरे को सीमित करने के लिए उचित प्रयास करना होगा, जिसमें प्रकटीकरण अनुरोधों का विरोध करने में हमारी सहायता करना शामिल है।',
    block16:
      '(b) सुरक्षा। सेवा के उपयोग और उपयोग की सुरक्षा के लिए आपको उचित और उचित उपायों को लागू करना होगा। यदि आप सेवा के अपने उपयोग से संबंधित किसी भी कमजोरियों या उल्लंघनों की खोज करते हैं, तो आपको तुरंत NOAM से संपर्क करना चाहिए और भेद्यता या उल्लंघन का विवरण प्रदान करना होगा।',
    block17:
      '((ग) व्यक्तिगत डेटा का प्रसंस्करण। यदि आप व्यक्तिगत डेटा को संसाधित करने के लिए सेवा का उपयोग करते हैं, तो आपको कानूनी रूप से पर्याप्त गोपनीयता विवरण प्रदान करना होगा और ऐसे डेटा को संसाधित करने के लिए आवश्यक सहमति प्राप्त करनी चाहिए, और आप हमें वारंट करते हैं कि आप लागू कानून के अनुसार ऐसे डेटा को संभालते हैं।',
    block18:
      '(ए) समाप्ति; निलंबन। ये शर्तें सेवा के आपके पहले उपयोग से प्रभावी होंगी और समाप्त होने तक प्रभावी रहेगी। आप सेवा और सामग्री के उपयोग को बंद करके किसी भी कारण से किसी भी समय इन शर्तों को समाप्त कर सकते हैं। हम किसी भी कारण से पूर्व सूचना के साथ इन शर्तों को समाप्त कर सकते हैं। यदि आप भौतिक रूप से धारा 2 (उपयोग आवश्यकताओं), धारा 5 (गोपनीयता, सुरक्षा, और डेटा संरक्षण), धारा 8 (विवाद समाधान), या धारा 9 (सामान्य शर्तों), या यदि हमारे नियंत्रण परिवर्तनों से परे किसी भी तृतीय-पक्ष प्रौद्योगिकी प्रदाता के साथ हमारे संबंध, या कानून या सरकार के अनुरोधों के अनुपालन के लिए, या कानून या सरकार के अनुरोधों के अनुपालन के लिए, तो हम तुरंत इन शर्तों को तुरंत समाप्त कर सकते हैं। यदि आप इन शर्तों का पालन करने में विफल रहते हैं, या यदि आपका उपयोग हमें या किसी तीसरे पक्ष के लिए सुरक्षा जोखिम पैदा करता है, या यदि हमें संदेह है कि आपका उपयोग धोखाधड़ी है या हमें या किसी तीसरे पक्ष को देयता के लिए उजागर कर सकता है, तो हम सेवा तक आपकी पहुंच को निलंबित कर सकते हैं।',
    block19:
      '(b) समाप्ति के प्रभाव। समाप्ति पर, आप सेवा का उपयोग करके बंद कर देंगे और हमारे द्वारा निर्देशित किसी भी गोपनीय जानकारी को तुरंत वापस या नष्ट कर देंगे। इन शर्तों के प्रावधान जो उनकी प्रकृति से समाप्ति या समाप्ति से बचने चाहिए, जिसमें धारा 3 और 5-9 तक सीमित नहीं है, जीवित रहेंगे।',
    block2:
      'हमारे एप्लिकेशन प्रोग्रामिंग इंटरफेस, सॉफ़्टवेयर, टूल्स, डेवलपर सेवाओं, डेटा, प्रलेखन और वेबसाइट (सामूहिक रूप से "सेवाओं" के रूप में संदर्भित) सहित NOAM की सेवाओं के आपके उपयोग पर उपयोग करने की ये शर्तें लागू होती हैं। हमारी सेवाओं का उपयोग करके, आप इन शर्तों का पालन करने के लिए सहमत हैं। हमारी गोपनीयता नीति बताती है कि हम व्यक्तिगत जानकारी को कैसे एकत्र और उपयोग करते हैं।',
    block20:
      '(ए) क्षतिपूर्ति। आप हमें, हमारे सहयोगियों, और हमारे कर्मियों को किसी भी दावे, नुकसान, और खर्चों (वकीलों की फीस सहित) के खिलाफ हानिरहित, और हमारे कर्मियों को सेवा के उपयोग से संबंधित या आपकी सामग्री, सेवा से संबंधित उत्पादों या सेवाओं के उपयोग और इन शर्तों या लागू कानूनों के उल्लंघन से संबंधित होने के कारण, हमारे कर्मियों को हानिरहित, क्षतिपूर्ति और पकड़ लेंगे।',
    block21:
      '(b) अस्वीकरण। सेवा प्रदान की जाती है "जैसा है।" कानून द्वारा अनुमति दी गई सीमा तक, हम और हमारे सहयोगी और लाइसेंसकर्ता सेवा के बारे में किसी भी प्रकार का कोई प्रतिनिधित्व या वारंटी नहीं देते हैं और कोई वारंटी नहीं देते हैं, लेकिन व्यापारिकता की वारंटी, किसी विशेष उद्देश्य के लिए फिटनेस, संतोषजनक गुणवत्ता, गैर-उल्लंघन, और शांत आनंद, और व्यापार के पाठ्यक्रम के लिए उत्पन्न होने वाले किसी भी वारंटी के लिए सीमित नहीं हैं। हम वारंट नहीं करते हैं कि सेवा निर्बाध, सटीक, या त्रुटि-मुक्त होगी, या यह कि कोई भी सामग्री सुरक्षित होगी, खो नहीं जाएगी, या परिवर्तित नहीं की जाएगी।',
    block22:
      '(c) देयता की सीमा। न तो हम, हमारे सहयोगी, और न ही हमारे लाइसेंसकर्ता किसी भी अप्रत्यक्ष, आकस्मिक, विशेष, परिणामी, या दंडात्मक क्षति के लिए उत्तरदायी होंगे, जिसमें मुनाफे की हानि, प्रतिष्ठा की हानि, उपयोग में कमी, डेटा की हानि, डेटा की हानि, या अन्य अमूर्त नुकसान शामिल हैं, भले ही हमें इस तरह के नुकसान की संभावना की सलाह दी गई हो। इन शर्तों के तहत, हमारी कुल देयता उस शुल्क से अधिक नहीं होगी जो आपके द्वारा दी गई बारह (12) महीनों में सेवा के लिए भुगतान की गई फीस या एक सौ अमेरिकी डॉलर ($ 100), जो भी अधिक हो। इस खंड में सीमाएं लागू कानून द्वारा अनुमत अधिकतम सीमा तक लागू होती हैं।',
    block23:
      'सेवाओं के नियमों और सेवाओं का उपयोग संयुक्त राज्य अमेरिका के कानूनों द्वारा नियंत्रित किया जाता है, सिवाय अमेरिकी कानूनों के नियमों के संघर्ष को छोड़कर। आपके आवेदन का उपयोग अन्य स्थानीय, राज्य, राष्ट्रीय या अंतर्राष्ट्रीय कानूनों के अधीन हो सकता है। इन शर्तों से संबंधित किसी भी कानूनी कार्रवाई या कार्यवाही को विशेष रूप से संयुक्त राज्य अमेरिका की अदालतों में लाया जाएगा, और आप ऐसी अदालतों के व्यक्तिगत अधिकार क्षेत्र को प्रस्तुत करने के लिए सहमत हैं।',
    block24:
      '(ए) पार्टियों का संबंध। NOAM और आप स्वतंत्र ठेकेदार हैं, और न ही पार्टी के पास दूसरे पक्ष का प्रतिनिधित्व करने या बांधने की शक्ति है या दूसरे पक्ष की पूर्व लिखित सहमति के बिना दूसरे पक्ष के लिए दायित्वों को ग्रहण करना है।',
    block25:
      '(b) ब्रांड उपयोग। आप हमारी पूर्व लिखित सहमति के बिना NOAM या इसके किसी भी सहयोगी के नाम, लोगो या ट्रेडमार्क का उपयोग नहीं कर सकते हैं।',
    block26:
      'यदि इन शर्तों का कोई प्रावधान अमान्य, अवैध या अप्राप्य होने के लिए निर्धारित किया जाता है, तो शेष प्रावधान पूर्ण शक्ति और प्रभाव में रहेंगे।',
    block3:
      'यदि आप 18 वर्ष से कम उम्र के हैं, तो आपको सेवा का उपयोग करने के लिए अपने माता -पिता या कानूनी अभिभावकों से अनुमति प्राप्त करनी चाहिए। यदि आप किसी अन्य व्यक्ति या संस्था की ओर से सेवा का उपयोग कर रहे हैं, तो आपको उनकी ओर से इन शर्तों को स्वीकार करने के लिए अधिकृत होना चाहिए। आपको किसी खाते के लिए पंजीकरण करने के लिए सटीक और पूरी जानकारी प्रदान करनी होगी। आप अपने संगठन के बाहर किसी को भी अपनी एक्सेस क्रेडेंशियल्स या खाता प्रदान नहीं कर सकते हैं, और आप अपने क्रेडेंशियल्स का उपयोग करके आयोजित सभी गतिविधियों के लिए जिम्मेदार हैं।',
    block4:
      '(ए) सेवा का उपयोग। आप इन शर्तों के तहत सेवा का उपयोग कर सकते हैं, और हम आपको सेवा का उपयोग करने के लिए एक गैर-अनन्य अधिकार प्रदान करते हैं। सेवा का उपयोग करते समय, आप इन शर्तों और सभी लागू कानूनों का पालन करेंगे। हम और हमारे सहयोगी सेवा में सभी अधिकारों, शीर्षक और हितों के मालिक हैं।',
    block5:
      '(b) प्रतिक्रिया। हम प्रतिक्रिया, टिप्पणियों, विचारों, सुझावों और सुधारों का स्वागत करते हैं। यदि आप ऐसी कोई सामग्री प्रदान करते हैं, तो हम इसका उपयोग बिना किसी प्रतिबंध के और बिना मुआवजे के कर सकते हैं।',
    block6:
      '(c) प्रतिबंध। आप नहीं कर सकते हैं: (1) इस तरह से सेवा का उपयोग करें जो दूसरों के किसी भी अधिकार का उल्लंघन, दुरुपयोग या उल्लंघन करता है; (2) रिवर्स इंजीनियर, डिकम्पिल, डिसेबिल, ट्रांसलेट, या अन्यथा सर्विस मॉडल, एल्गोरिदम और सिस्टम के स्रोत कोड या अंतर्निहित घटकों की खोज करने का प्रयास करते हैं (जब तक कि इस तरह के प्रतिबंध लागू कानून द्वारा निषिद्ध नहीं हैं); (3) NOAM के साथ प्रतिस्पर्धा करने वाले मॉडल विकसित करने के लिए सेवा के आउटपुट का उपयोग करें; (4) किसी भी स्वचालित या प्रोग्रामिंग विधियों का उपयोग करके सेवा से डेटा या आउटपुट निकालें, जब तक कि एपीआई के माध्यम से अनुमति न हो, जिसमें स्क्रैपिंग, वेब कटाई, या वेब डेटा निष्कर्षण शामिल है; (५) जब यह कृत्रिम रूप से उत्पन्न होने पर सेवा के उत्पादन का प्रतिनिधित्व करता है, तो यह नहीं होता है, या अन्यथा हमारी उपयोग नीतियों का उल्लंघन करता है; (६) हमारी पूर्व सहमति के बिना एपीआई कुंजियों को खरीदना, बेचना या स्थानांतरित करना; या (7) हमें 13 वर्ष से कम उम्र के बच्चों की किसी भी व्यक्तिगत जानकारी या डिजिटल सहमति की लागू आयु प्रदान करता है। आप हमारे प्रलेखन में किसी भी दर सीमा और अन्य आवश्यकताओं का पालन करेंगे।',
    block7:
      '(d) तृतीय-पक्ष सेवाएं। सेवा से जुड़े किसी भी तृतीय-पक्ष सॉफ़्टवेयर, सेवाओं, या अन्य उत्पादों को अपनी शर्तों द्वारा नियंत्रित किया जाता है, और हम तृतीय-पक्ष उत्पादों के लिए जिम्मेदार नहीं हैं।',
    block8:
      '(a) आपकी सामग्री। आप सेवा के लिए इनपुट ("इनपुट") प्रदान कर सकते हैं और इनपुट के आधार पर उत्पन्न और वापस किए गए आउटपुट ("आउटपुट") प्राप्त कर सकते हैं (सामूहिक रूप से "सामग्री" के रूप में संदर्भित)। पार्टियों के बीच, और लागू कानून द्वारा अनुमत सीमा तक, आप सभी इनपुट के मालिक हैं। NOAM सेवा प्रदान करने और बनाए रखने, लागू कानूनों का पालन करने और हमारी नीतियों को लागू करने के लिए सामग्री का उपयोग कर सकता है। आप सामग्री के लिए जिम्मेदार हैं, जिसमें यह सुनिश्चित करना शामिल है कि यह किसी भी लागू कानूनों या इन शर्तों का उल्लंघन नहीं करता है।',
    block9:
      '(b) सटीकता। आर्टिफिशियल इंटेलिजेंस और मशीन लर्निंग तेजी से अनुसंधान के क्षेत्र विकसित कर रहे हैं। हम लगातार अधिक सटीक, विश्वसनीय, सुरक्षित और लाभकारी बनाने के लिए अपनी सेवा में सुधार करने का प्रयास करते हैं। मशीन लर्निंग की संभाव्य प्रकृति को देखते हुए, हमारी सेवा का उपयोग करने से कुछ मामलों में गलत आउटपुट हो सकता है, जो वास्तविक व्यक्तियों, स्थानों या तथ्यों को सटीक रूप से प्रतिबिंबित नहीं कर सकता है। आपको अपने उपयोग के मामले के आधार पर किसी भी आउटपुट की सटीकता का उचित आकलन करना चाहिए, जिसमें मैन्युअल रूप से आउटपुट की समीक्षा करना शामिल है।',
    subTitle1: 'पंजीकरण और अभिगम',
    subTitle10: 'विच्छेदनीयता',
    subTitle2: 'उपयोग आवश्यकताएँ',
    subTitle3: 'सामग्री',
    subTitle4: 'शुल्क और भुगतान',
    subTitle5: 'गोपनीयता, सुरक्षा और डेटा संरक्षण',
    subTitle6: 'अवधि और समापन',
    subTitle7: 'क्षतिपूर्ति; अस्वीकरण; दायित्व की सीमा',
    subTitle8: 'शासी कानून और अधिकार क्षेत्र',
    subTitle9: 'सामान्य शर्तें',
    title: 'सेवा की शर्तें',
    updateTime: 'अद्यतन: 15 मार्च, 2024',
  },
  trialModal: {
    btn: 'अब शुरू करें （केवल $ 0.99）',
    chat: 'चैटपडीएफ',
    desc1: 'आपके परीक्षण के बाद, आपसे $ 180 का वार्षिक शुल्क लिया जाएगा',
    desc2: 'कभी भी रद्द करें',
    focus: 'ध्यान केंद्रित',
    hover: 'होवर अनुवाद',
    image: 'छवि अनुवाद',
    installBtn: 'अपना उपहार प्राप्त करने के लिए अभी स्थापित करें',
    memo: 'पसंदीदा प्रबंधन',
    pdf: 'पीडीएफ समानांतर अनुवाद',
    realtime: 'तुरंत अनुवाद',
    select: 'शब्द चयन अनुवाद',
    title: 'आपका स्वागत है उपहार',
    trialText: '7-दिवसीय परीक्षण',
    video: 'वीडियो अनुवाद',
    videoSummary: 'वीडियो सारांश',
    web: 'समानांतर अनुवाद',
    webSummary: 'वेब सारांश',
  },
  upgradeModal: {
    btn: 'अभी अपग्रेड करें',
    chat: {
      free: 'आप CHATPDF सीमा तक पहुंच गए हैं',
      pro: 'आप इस महीने के लिए CHATPDF सीमा तक पहुंच गए हैं',
    },
    contactStr:
      'कृपया अगले रीसेट की प्रतीक्षा करें, या हमसे संपर्क करें@noam.tools पर संपर्क करें।',
    limitAlertStr: 'आप अपनी मुफ्त योजना सीमा तक पहुँच गए हैं। जारी रखने के लिए अपग्रेड।',
    more: 'योजनाओं को देखें',
    pageLimit: { free: 'आप पीडीएफ पेज सीमा तक पहुंच गए हैं' },
    title: 'अनुस्मारक',
    upgradeAlertStr: 'आप अपनी मुफ्त योजना सीमा तक पहुँच गए हैं। जारी रखने के लिए अपग्रेड।',
    upload: {
      free: 'आप अपनी पीडीएफ अनुवाद सीमा तक पहुंच गए हैं',
      pro: 'आप इस महीने के लिए अपनी पीडीएफ अनुवाद सीमा तक पहुंच गए हैं',
    },
  },
  welfare: {
    newUser: {
      joinBtn: 'अब शामिल हों',
      label: 'नए उपयोगकर्ता लाभ:',
      remain: 'केवल 30 बचा है',
      text: 'केवल 100 स्पॉट उपलब्ध हैं! अब तुम्हारा पकड़ो!',
    },
  },
  aiPdfTranslator: {
    title: 'मुफ़्त एआई पीडीएफ़ अनुवादक: किसी भी भाषा में तुलना सहित PDF अनुवाद करें',
    desc: 'एआई की मदद से PDF फ़ाइलों को किसी भी भाषा में आसानी से अनुवाद करें। मूल और अनूदित पाठ को एक साथ, तेज़ और मुफ्त में तुलना करें।',
    keywords: 'GPT-4, एआई सहायक, अनुवाद, सारांश, फोकस, ChatPDF, मेमो, दक्षता',
    sourceToTarget: {
      title: 'नि:शुल्क PDF अनुवाद उपकरण: {{source}} को {{target}} में मुफ्त में अनुवाद करें',
      desc: 'अपने PDF फाइलों का किसी भी स्रोत भाषा से अपनी पसंदीदा भाषा में नि:शुल्क अनुवाद करें। तेज़, सटीक और सुरक्षित PDF अनुवाद, उन्नत AI द्वारा संचालित।',
    },
    headerIntroduce: {
      title: 'Noam: सिर्फ़ ऑनलाइन अनुवाद से कहीं बढ़कर',
      introduce1: {
        title: 'Noam · PDF रीडर',
        desc: '✨साइड-बाय-साइड अनुवाद + एआई प्रश्नोत्तर। अपने PDF को तेज़ी और सटीकता से लक्षित भाषा में अनुवाद करें। सामग्री से संबंधित सवाल पूछें और अपने PDF को गहराई से समझें।',
      },
      introduce2: {
        title: 'Noam · साइड-बाय-साइड अनुवाद एक्सटेंशन',
        desc: '👏अपनी सभी वेबपेज अनुवाद जरूरतों को हल करें:',
        detail1: { title: 'वेबपेज अनुवाद: ', desc: 'साइड-बाय-साइड द्विभाषी दृश्य।' },
        detail2: { title: 'शब्द अनुवाद: ', desc: 'एक क्लिक में त्वरित अनुवाद।' },
        detail3: { title: 'तत्काल अनुवाद: ', desc: 'शब्दों या वाक्यों का तुरंत अनुवाद करें।' },
        detail4: { title: 'इमेज अनुवाद: ', desc: 'चित्रों को अनूदित चित्रों से बदलें।' },
        detail5: { title: 'वीडियो अनुवाद: ', desc: 'बेहतर अनुभव के लिए द्विभाषी सबटाइटल।' },
        footer: 'और भी अधिक स्मार्ट अनुवाद के लिए एआई-संचालित पढ़ने की सुविधाएँ आज़माएँ!',
      },
    },
    subtitle: 'PDF को ऑनलाइन मुफ़्त में अनुवाद करें',
    introduce: {
      module1: {
        detail1: {
          title: 'रीयल-टाइम साइड-बाय-साइड PDF अनुवाद',
          desc1: 'मूल और अनूदित सामग्री को तुरंत सिंक्रोनाइज़्ड, साइड-बाय-साइड लेआउट में दिखाएँ',
          desc2: 'सिंक्रोनाइज़्ड स्क्रॉलिंग के साथ दोनों वर्शन को आसानी से तुलना करें',
          desc3: 'एक जैसी फॉर्मेटिंग बनाए रखें ताकि पढ़ने का अनुभव निरंतर रहे',
        },
        detail2: {
          title: 'सटीक सामग्री मिलान और सत्यापन',
          desc1: 'आसान सत्यापन के लिए स्रोत और अनूदित पाठ के बीच बिल्कुल सही मेल',
          desc2: 'सामग्री का हर भाग दोनों वर्शन में सटीक मेल खाता है',
          desc3: 'अनुवाद में अंतर जल्दी पकड़ें और हल करें, ताकि विश्वसनीय परिणाम मिले',
        },
      },
      module2: {
        detail1: {
          title: 'सटीक अनुवाद के लिए कई एडवांस्ड एआई मॉडल',
          desc1: 'अपने अनुवाद की जरूरतों के अनुसार प्रमुख एआई मॉडलों में से चयन करें',
          desc2: 'विभिन्न दस्तावेज़ प्रकारों और उद्योगों के लिए सबसे अच्छे परिणाम सुनिश्चित करें',
          desc3: 'लचीले मॉडल विकल्प हर परिस्थिति के लिए अनुकूल समाधान देते हैं',
        },
        detail2: {
          title: 'हर प्रकार की सामग्री के लिए उन्नत एआई अनुवाद',
          desc1: 'हमारा शक्तिशाली एआई मॉडल उच्च सटीकता और स्वाभाविक भाषा समझ प्रदान करता है',
          desc2: 'तकनीकी, अकादमिक और रचनात्मक दस्तावेज़ आसानी से संभालता है',
          desc3: 'आपकी सभी अनुवाद आवश्यकताओं के लिए भरोसेमंद परिणाम देता है',
          desc4:
            'सर्वोत्तम प्रदर्शन के लिए विभिन्न सामग्री प्रकारों के अनुसार स्मार्ट रूप से ढलता है',
        },
      },
      module3: {
        detail1: {
          title: 'इंटेलिजेंट डॉक्युमेंट इंटरैक्शन',
          desc1: 'एडवांस्ड एआई से अपने PDF और प्रेजेंटेशन फाइल्स से आसानी से संवाद करें',
          desc2: 'डॉक्युमेंट की सामग्री पर तुरंत सवाल पूछें और सही जवाब पाएं',
          desc3: 'लंबे दस्तावेज़ों के लिए संक्षिप्त सारांश जल्दी तैयार करें',
        },
        detail2: {
          title: 'गहरी सामग्री विश्लेषण और निर्बाध एकीकरण',
          desc1: 'एआई-आधारित समझ के साथ मुख्य जानकारी निकालें और जटिल डेटा का विश्लेषण करें',
          desc2: 'तकनीकी, शैक्षणिक या रचनात्मक सामग्री में गहरी समझ हासिल करें',
          desc3:
            'संपूर्ण डॉक्युमेंट प्रबंधन समाधान के लिए हमारे PDF अनुवादक के साथ सहज रूप से एकीकृत',
        },
      },
      module4: {
        detail1: {
          title: 'PDF अनुवाद से आगे: ऑल-इन-वन वेबपेज अनुवाद समाधान',
          desc: 'हमारा शक्तिशाली साइड-बाय-साइड अनुवाद एक्सटेंशन खोजें, जो हर ऑनलाइन पढ़ाई के लिए डिज़ाइन किया गया है।',
          desc1:
            'वेबपेज अनुवाद: सिंक्रोनाइज़्ड साइड-बाय-साइड व्यू में द्विभाषी सामग्री का आनंद लें',
          desc2: 'शब्द अनुवाद: हाइलाइट किए गए शब्दों को तुरंत एक क्लिक में अनुवाद करें',
          desc3: 'तत्काल अनुवाद: किसी भी पाठ या वाक्य का मौके पर ही अनुवाद करें',
          desc4: 'इमेज अनुवाद: मूल चित्रों को स्वचालित रूप से अनूदित संस्करणों से बदलें',
          desc5: 'वीडियो अनुवाद: बेहतर अनुभव के लिए द्विभाषी सबटाइटल के साथ वीडियो देखें',
        },
      },
    },
    question: {
      title: 'अक्सर पूछे जाने वाले सवाल',
      answer1: {
        title: 'क्या Noam PDF Translator PDF अनुवाद के लिए मुफ़्त है?',
        content:
          'हाँ, आप Sider PDF Translator से PDF मुफ़्त में अनुवाद कर सकते हैं! हम 5,000 टोकन का मुफ़्त कोटा देते हैं, जो अधिकांश सामान्य PDF दस्तावेज़ों के लिए पर्याप्त है। यदि आपको बड़े फ़ाइल या उन्नत सुविधाएँ चाहिए, तो आप हमारे प्रीमियम प्लान में अपग्रेड कर सकते हैं और भी ज्यादा क्षमताओं के लिए।',
      },
      answer2: {
        title: 'Noam PDF Translator कितना सटीक है?',
        content:
          'Noam PDF Translator उन्नत एआई तकनीक और आपके दस्तावेज़ों की गहन समझ के साथ अत्यंत सटीक अनुवाद प्रदान करता है। कोई भी स्वचालित अनुवाद पूरी तरह त्रुटिहीन नहीं होता, लेकिन हमारा साइड-बाय-साइड डिस्प्ले आपको हर अनुवाद को आसानी से जाँचने और सुधारने देता है, ताकि अंतिम परिणाम आपकी गुणवत्ता की अपेक्षाओं पर खरा उतरे। Noam के साथ भरोसेमंद और सटीक PDF अनुवाद का अनुभव लें।',
      },
      answer3: {
        title: 'क्या मैं स्कैन किए गए PDF अनुवाद सकता हूँ?',
        content:
          'हाँ, आप हमारे इन-बिल्ट OCR (ऑप्टिकल कैरेक्टर रिकग्निशन) तकनीक के साथ स्कैन किए गए PDF का अनुवाद कर सकते हैं। हमारा सिस्टम अपने आप स्कैन किए गए दस्तावेज़ों और इमेज-बेस्ड PDF से टेक्स्ट निकालता है, फिर आपके लिए कंटेंट अनुवाद करता है। इससे गैर-संपादन योग्य या केवल चित्र वाले PDF भी सही ढंग से अनुवादित हो सकते हैं।',
      },
      answer4: {
        title: 'अनुवाद में कितना समय लगता है?',
        content:
          'अनुवाद तेज़ और कुशल है — अधिकांश दस्तावेज़ कुछ सेकंड से कुछ मिनटों में प्रोसेस हो जाते हैं, उनकी लंबाई और जटिलता के अनुसार। उदाहरण के लिए, एक सामान्य 10-पेज PDF को अनुवाद करने में आमतौर पर 2 मिनट से कम समय लगता है। अपने सभी दस्तावेज़ों की अनुवाद जरूरतों के लिए तेज़ सेवा पाएं!',
      },
      answer5: {
        title: 'क्या मैं पढ़ने के लिए साइड-बाय-साइड व्यू रख सकता हूँ?',
        content:
          'हाँ, आप हमेशा अपने दस्तावेज़ साइड-बाय-साइड देख सकते हैं। यह लेआउट आपको मूल और अनूदित कंटेंट को आसानी से तुलना करने देता है, जिससे पढ़ाई का अनुभव आसान और सुचारू रहता है।',
      },
    },
    freeTrial: 'मुफ़्त ट्रायल',
    toLanguage: { title: '{{lang}} पीडीएफ एआई अनुवाद जोड़े', item: '{{source}} से {{target}}' },
  },
  aiPdfTranslate: {
    header: {
      blog: 'ब्लॉग',
      pricing: 'मूल्य निर्धारण',
      features: 'विशेषताएँ',
      button: 'अभी अनुवाद करें',
      faq: 'अक्सर पूछे जाने वाले प्रश्न',
    },
    hero: {
      upload: {
        title: 'अपना पीडीएफ अपलोड करें',
        highlight: 'ब्राउज़ करने के लिए क्लिक करें',
        max: 'मैक्स',
        desc: 'या ड्रैग एंड ड्रॉप करें',
      },
      to: 'को',
      pill: 'एआई-संचालित पीडीएफ अनुवादक',
      title: 'मुफ्त पीडीएफ अनुवादक',
      model: 'जीपीटी-4 और क्लॉड',
      support: 'ओसीआर समर्थन',
      desc: 'तत्काल, सटीक अनुवाद जो मूल लेआउट को संरक्षित करते हैं। नोएम AI OCR और साइड-बाय-साइड व्यू का समर्थन करता है।',
      free: 'मुफ्त परीक्षण',
      translated: 'नोम द्वारा अनुवादित',
      complete: 'अनुवाद पूरा',
    },
    ticker: {
      pdf: 'पीडीएफ अनुवाद',
      ocr: 'ओसीआर प्रौद्योगिकी',
      format: 'फॉर्मेट रिटेंशन',
      multi: 'बहु-भाषा',
      side: 'साथ-साथ',
      chat: 'पीडीएफ के साथ चैट करें',
      web: 'वेब अनुवाद',
      secure: 'सुरक्षित और निजी',
    },
    comparison: {
      bad: {
        title: 'मानक अनुवाद',
        head: 'फॉर्मेटिंग और संदर्भ खोया गया',
        text1: 'त्रुटि: लेआउट टूट गया है। छवियां गलत जगह पर हैं।',
        text2: 'पाठ ओवरलैप होता है और फोंट असंगत हैं। पढ़ने में मुश्किल और अनप्रोफेशनल...',
      },
      dump: { title: 'प्लेन टेक्स्ट डंप' },
      good: {
        title: 'नोएम एआई अनुवाद',
        tag: 'परफेक्ट रिजल्ट',
        sub: 'परफेक्ट फॉर्मेटिंग, संदर्भ जागरूक',
      },
      title: 'नोम AI क्यों चुनें?',
      desc: 'कॉपी-पेस्ट अनुवाद से जूझना बंद करें। मानक टूल और हमारे AI-संचालित संदर्भ-सचेत अनुवाद के बीच अंतर का अनुभव करें।',
    },
    showcase: {
      title1: 'कोई भी दस्तावेज़',
      kicker: 'समर्थित दस्तावेज़',
      title2: 'कोई भी भाषा',
      carousel1: 'कला',
      carousel2: 'वास्तुकला',
      carousel4: 'दवा',
      carousel3: 'अकादमिक जर्नल',
      carousel5: 'वित्त',
      note: 'तकनीकी, शैक्षिक और रचनात्मक दस्तावेज़ों को आसानी से संभालें।',
      carousel6: 'कानून',
      carousel8: 'नीति',
      carousel7: 'अनुबंध',
    },
    features: {
      big: {
        title: 'उन्नत AI मॉडल (GPT-4, क्लॉड)',
        desc: 'अपनी अनुवाद आवश्यकताओं के अनुरूप प्रमुख AI मॉडलों में से चुनें। विभिन्न दस्तावेज़ प्रकारों के लिए इष्टतम परिणाम सुनिश्चित करें।',
      },
      grid1: {
        title: 'ओसीआर समर्थन',
        desc: 'स्कैन किए गए पीडीएफ और इमेज से पाठ तत्काल निकालें और अनुवाद करें।',
      },
      grid2: {
        title: 'हाई-रिज़ एक्सपोर्ट',
        desc: 'मूल लेआउट के साथ पीडीएफ प्रारूप में अपने अनुवादित दस्तावेज़ डाउनलोड करें।',
      },
      grid3: {
        title: 'समक्ष तुलना',
        desc: 'मूल और अनुवादित पाठ की तुलना करने के लिए सिंक्रनाइज़्ड स्क्रॉलिंग।',
      },
      title1: 'सिर्फ अनुवाद से ज्यादा',
      title2: 'यह एक क्रांति है',
      line1: 'तकनीकी पेपर.pdf',
      line3: 'मॉडल: GPT-4o (उच्च परिशुद्धता)',
      line2: 'भाषा का पता लगा रहा है: अंग्रेजी...',
      line4: 'अनुवाद पूर्ण (99% सटीकता)',
    },
    testimonials: {
      review1: {
        role: 'शोधकर्ता',
        content:
          'नोएम एआई ने मुझे शैक्षिक पत्रों का अनुवाद करने में घंटों बचाए। तकनीकी शब्दों को सत्यापित करने के लिए साइड-बाय-साइड दृश्य अविश्वसनीय रूप से मददगार है।',
      },
      review2: {
        role: 'वैश्विक मार्केटर',
        content:
          'मैंने इस्तेमाल किया है सबसे अच्छा पीडीएफ अनुवादक। यह मूल फॉर्मेटिंग को पूरी तरह से बनाए रखता है, जो हमारे मार्केटिंग डेकों के लिए महत्वपूर्ण है।',
      },
      review3: {
        role: 'कानूनी सलाहकार',
        content:
          'सटीक और तेज़। मैं इसका उपयोग अनुबंध अनुवादों के लिए करता हूं और स्कैन किए गए दस्तावेज़ों के लिए OCR फीचर बिल्कुल सही तरीके से काम करता है।',
      },
      kicker: 'उपयोगकर्ताओं द्वारा पसंद किया गया',
      title: 'हमारे उपयोगकर्ता क्या कहते हैं',
    },
    cta: {
      title: 'भाषा की बाधाओं को तोड़ने के लिए तैयार हैं?',
      button: 'मुफ्त में अनुवाद करना शुरू करें',
      hint: '',
      desc: '10,000+ उपयोगकर्ताओं के साथ जुड़ें और आज ही Noam AI के साथ अपने दस्तावेज़ों का अनुवाद शुरू करें।',
    },
    languagePairs: {
      title: 'अंग्रेजी पीडीएफ एआई अनुवाद युग्म',
      desc: 'नोम AI द्वारा समर्थित लोकप्रिय अनुवाद दिशाएँ',
    },
    footer: { about: 'हमारे बारे में', privacy: 'गोपनीयता नीति', contact: 'सपोर्ट से संपर्क करें' },
  },
}

export default TRANSLATION
